import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { postLoginRedirect } from '@/shared/auth/post-login-redirect'
import { useAuthStore } from '@/shared/auth/stores/authStore'

// Parent layout for /user-management/* routes. Auth + role gating —
// admin/super_admin only. HODs go to /hod/dashboard, FOs to
// /mobile-only. Leaf routes (.index, .departments) inherit this guard.
export const Route = createFileRoute('/user-management')({
  beforeLoad: () => {
    const state = useAuthStore.getState()
    if (!state.isAuthenticated) {
      throw redirect({ to: '/login' })
    }
    const role = state.user?.role_name
    if (role !== 'super_admin' && role !== 'admin') {
      throw redirect({ to: postLoginRedirect(role) })
    }
  },
  component: () => <Outlet />,
})
